import React, { Component } from 'react';
import { ApolloClient, ApolloLink, gql } from '@apollo/client';
import { ApolloProvider } from '@apollo/react-hooks';
import { setConfig } from 'react-hot-loader';
import { InMemoryCache } from '@apollo/client/cache';
import { onError } from '@apollo/link-error';
import { setContext } from '@apollo/link-context';
import { notification } from 'antd';
import update from 'immutability-helper';
import { createUploadLink } from 'apollo-upload-client';

import storage from '$lib/storage';
import { CHROME } from '$queries/chrome';
import PreBoot from './PreBoot';
import Hot from './Hot';

import 'react-table/react-table.css';
import 'antd/dist/antd.less';

const GRAPHQL_URL = process.env.GRAPHQL_URL; // eslint-disable-line prefer-destructuring

setConfig({ logLevel: 'debug' });

const clientCache = new InMemoryCache({
  dataIdFromObject: (o) => o.uuid || null,
  possibleTypes: {
    GrantSourceTarget: ['StaffUser', 'Product'],
  },
});

const cacheInit = (cache) => {
  cache.writeQuery({
    query: gql`
      query Chrome {
        chrome {
          sidebarExpanded
        }
      }
    `,
    data: {
      chrome: {
        sidebarExpanded: false,
      },
    },
  });
};

const authLink = setContext((_, { headers }) => {
  const { email, accessToken } = storage.getAuth();
  return {
    headers: {
      ...headers,
      'ACHIEVABLE-ACCESS-TOKEN': accessToken,
      'ACHIEVABLE-USER-EMAIL': email,
    },
  };
});

const uploadLink = createUploadLink({
  uri: GRAPHQL_URL,
  credentials: 'same-origin',
});

const client = new ApolloClient({
  link: ApolloLink.from([
    onError(({ graphQLErrors, networkError }) => {
      if (graphQLErrors) {
        graphQLErrors.forEach(({ message, locations, path }) => {
          console.info('[GraphQL error]', { message, locations, path }); // eslint-disable-line no-console
          notification.error({
            message: 'Error',
            description: message,
          });
        });
      }
      if (networkError) {
        console.log('[Network error]', networkError); // eslint-disable-line no-console
      }
    }),
    authLink,
    uploadLink,
  ]),
  cache: clientCache,
  resolvers: {
    Mutation: {
      toggleSidebarExpanded: (_parent, _args, { cache }) => {
        const query = CHROME;
        const previous = cache.readQuery({ query });
        const data = update(previous, {
          chrome: {
            $toggle: ['sidebarExpanded'],
          },
        });
        cache.writeQuery({ query, data });
        return data;
      },
    },
  },
});

client.onResetStore(() => {
  cacheInit(clientCache);
});
cacheInit(clientCache);

class Root extends Component {
  render() {
    return (
      <PreBoot>
        <ApolloProvider client={client}>
          <Hot />
        </ApolloProvider>
      </PreBoot>
    );
  }
}

export default Root;
